import { render, staticRenderFns } from "./SelectorModulos.vue?vue&type=template&id=480da498"
import script from "./SelectorModulos.vue?vue&type=script&lang=js"
export * from "./SelectorModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports